var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-secondary',{staticClass:"pc-content",attrs:{"header":_vm.headerOptions}},[_c('page-container',[_c('page-content-text',{attrs:{"description":_vm.content}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }